import { gsap } from "gsap";
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

import scrollLock from 'scroll-lock';

let fixedEl = null;
let currentMedia = null;
let currentMediaRect = null;

let scrollbarWidth = null;

let nextMedia = null;
let nextMediaRect = null;

let closeButton = null;

export default {
	name: 'features-project',
    from: {
		custom: ({ current, next, trigger }) => {
			// const mobileBreakpoint = window.matchMedia('(max-width:991px)');
			// if (mobileBreakpoint.matches) {
			// 	return false;
			// }
			return true;
		},
		namespace: ['template-features'],
	},
	to: {
		namespace: ['single-project'],
	},
    leave({ current, next, trigger }) {
        return new Promise(resolve => {
            scrollbarWidth = scrollLock.getCurrentPageScrollBarWidth();
            document.dispatchEvent(new CustomEvent('disable-scroll'));
			current.container.classList.remove('ready-to-scroll');

            this.featuresCanvasElm = current.container.querySelector('#canvas');
            gsap.to(this.featuresCanvasElm, {
                autoAlpha: 0,
                duration: 0.3,
                ease: 'none',
                onComplete: () => {
                    resolve();
                }
            });

            resolve();

		});
    },
    afterLeave({ current, next, trigger }) {
        return new Promise(resolve => {

            // Current Media
            const currentProject = trigger.closest('[data-feature-item]').getAttribute('data-feature-item');
            currentMedia = current.container.querySelector('[data-feature-media="'+currentProject+'"').querySelector('[data-project-media]');
            if(!currentMedia) {
                return;
            }

            currentMediaRect = currentMedia.getBoundingClientRect();

            // Create Fixed Element
			fixedEl = document.createElement('div');

			gsap.set(fixedEl, {
				position: 'fixed',
				zIndex: -1,
				width: currentMediaRect.width,
				height: currentMediaRect.height,
				left: currentMediaRect.left,
				top: currentMediaRect.top,
				transformOrigin: 'top left',
                background: 'rgb(35,34,34)',
			});

            gsap.set(currentMedia, {
                autoAlpha: 0.7
            });

            document.body.appendChild(fixedEl);
			fixedEl.appendChild(currentMedia);

            document.dispatchEvent(new CustomEvent('hide-menu'));
            document.dispatchEvent(new CustomEvent('hide-switcher'));

			window.scrollTo(0, 0);

            // Prepare Next Container for revealing animation
			gsap.set(next.container, {
				autoAlpha: 0,
                zIndex: -2,
                position: 'relative'
			});

            closeButton = next.container.querySelector('[data-close-project]');
            gsap.set(closeButton, {
                autoAlpha: 0
            });

            resolve();

        });
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise(resolve => {

            // Next Media
			nextMedia = next.container.querySelector('[data-project-media]');
            const nextImageWrapper = nextMedia.closest('header');
			nextMediaRect = nextMedia.getBoundingClientRect();
			nextMedia.remove();

            const tl = gsap.timeline({
                delay: 0.3,
                onComplete: () => {
                    nextImageWrapper.appendChild(currentMedia);
					fixedEl.remove();

                    gsap.set(next.container, {
                        zIndex: 1,
                        position: 'static'
                    });

                    // Fade in Close Button
                    gsap.to(closeButton, {
                        autoAlpha: 1,

                        duration: 0.3,
                        ease: 'sine.inOut'
                    });

                    if(autoplayVideo) {
                        autoplayVideo.classList.remove('dont-update-my-source');
                    }

                    resolve();
                }
            });

            // Disperse all items but the trigger
            // const featureItems = current.container.querySelectorAll('[data-feature-item]:not(.is-active)');
            // featureItems.forEach(item => {
            //     const currentX = new WebKitCSSMatrix(getComputedStyle(item.querySelector('a')).transform).e;
            //     item.classList.add('is-transitioning');
            //     gsap.to(item.querySelector('a'), {
            //         x: currentX*1.3,

            //         duration: 0.6,
            //         ease: 'sine.inOut'
            //     });
            // });


            const autoplayVideo = currentMedia.querySelector('[data-autoplay-video]');
            if(autoplayVideo) {
                autoplayVideo.classList.add('dont-update-my-source');
            }

            // Fade in Image
            gsap.to(currentMedia, {
                autoAlpha: 1,
                duration: 0.6,
                ease: 'sine.in'
            });

            // Scroll to top but make sure Current Container stays in position
			gsap.set(current.container, {
				position: 'absolute',
				top: -window.scrollY + 'px',
				width: window.innerWidth-scrollbarWidth+'px',
				left: 0,
			});

            tl.to(current.container, {
                autoAlpha: 0,
                duration: 0.6,
                ease: 'sine.inOut',
                onComplete: () => {
                    gsap.set(document.documentElement, { // Hardcoded bacause sometimes next.container is not yet available
                        "--color": '35,34,34',
                        "--background": '249,248,246'
                    });
                }
            });

            tl.addLabel('fadedOut');

            tl.to(fixedEl, {
                height: nextMediaRect.height,

				ease: 'power2.inOut',
				duration: 0.8,
			}, 'fadedOut');

            tl.to(next.container, {
                autoAlpha: 1,

                ease: 'power2.inOut',
				duration: 0.8,
			}, 'fadedOut');

            tl.addLabel('inPosition');

		});
	},
	after({ current, next, trigger }) {
		return new Promise(resolve => {
            document.dispatchEvent(new CustomEvent('enable-scroll'));

            resolve();
		});
	},
};
